/*Strucutre:
url     => router path
name    => name to display in sidebar
slug    => router path name
roles   => roles that can access this menu item
icon    => Feather Icon component/icon name
tag     => text to display on badge
tagColor  => class to apply on badge element
i18n    => Internationalization
submenu   => submenu of current item (current item will become dropdown )
NOTE: Submenu don't have any icon(you can add icon if u want to display)
isDisabled  => disable sidebar item/group
*/

import {ADMIN_ROLE, FINANCE_ROLE, HR_ROLE, MANAGER_ROLE} from "../../../middlewares/permissions";
import i18n from "../../../utilities/i18n";

export default [
  {
    url:"/",
    name:i18n.t('modules.home'),
    slug:"home",
    icon:"HomeIcon",
  },
  {
    url:"/users",
    name:i18n.t('modules.users'),
    slug:"users",
    icon:"UserIcon",
    roles:[ADMIN_ROLE, HR_ROLE],
  },
  {
    url:"/clients",
    name:i18n.t('modules.clients'),
    slug:"clients",
    icon:"BriefcaseIcon",
    roles:[ADMIN_ROLE, HR_ROLE],
  },
  {
    url:"/projects",
    name:i18n.t('modules.projects'),
    slug:"projects",
    icon:"LayersIcon",
    roles:[ADMIN_ROLE, HR_ROLE, MANAGER_ROLE],
  },
  {
    url:"/timecard",
    name:i18n.t('modules.timecard'),
    slug:"timecard",
    icon:"ActivityIcon",
  },
  {
    url:"/payments",
    name:i18n.t('modules.payments'),
    slug:"payments",
    icon:"CreditCardIcon",
    roles:[ADMIN_ROLE, FINANCE_ROLE],
  },
  {
    url:"/ptos",
    name:i18n.t('modules.ptos'),
    slug:"ptos",
    icon:"CoffeeIcon",
  },
  {
    url:"/holidays",
    name:i18n.t('modules.holidays'),
    slug:"holidays",
    icon:"CalendarIcon",
    roles:[ADMIN_ROLE, HR_ROLE],
  },
  {
    url:"/configurations",
    name:i18n.t('modules.configurations'),
    slug:"configurations",
    icon:"SettingsIcon",
    roles:[ADMIN_ROLE, HR_ROLE],
  },
]
